import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { Capacitor } from '@capacitor/core';

/**
 * Hook para manejar feedback háptico (vibraciones) en dispositivos móviles.
 * Solo se activa si la aplicación se está ejecutando en un entorno nativo (Capacitor).
 */
export const useHaptics = () => {
  const isNative = Capacitor.isNativePlatform();

  const impactLight = async () => {
    if (isNative) {
      await Haptics.impact({ style: ImpactStyle.Light });
    }
  };

  const impactMedium = async () => {
    if (isNative) {
      await Haptics.impact({ style: ImpactStyle.Medium });
    }
  };

  const impactHeavy = async () => {
    if (isNative) {
      await Haptics.impact({ style: ImpactStyle.Heavy });
    }
  };

  const notifySuccess = async () => {
    if (isNative) {
      await Haptics.notification({ type: NotificationType.Success });
    }
  };

  const notifyWarning = async () => {
    if (isNative) {
      await Haptics.notification({ type: NotificationType.Warning });
    }
  };

  const notifyError = async () => {
    if (isNative) {
      await Haptics.notification({ type: NotificationType.Error });
    }
  };

  const vibrate = async () => {
    if (isNative) {
      await Haptics.vibrate();
    }
  };

  return {
    impactLight,
    impactMedium,
    impactHeavy,
    notifySuccess,
    notifyWarning,
    notifyError,
    vibrate,
  };
};
